export default __webpack_public_path__ + "static/media/icon_person_on.88b57da2.svg";